export default Object.freeze({
  HOME: 'home',
  DASHBOARD: 'dashboard',
  CS_REPORT: 'customer-service-report',
  CL_REPORT: 'course-leaders-report',
  LOGIN: 'login'
})
